import { PermissionLevel } from '@/utils/permission';
export const companyStructureRoutes = [
  {
    component: () => import('@/pages/masterdata/companies/index.vue'),
    meta: {
      permissions: [{ Company: PermissionLevel.Read }],
      title: 'menu_companies'
    },
    name: 'Companies',
    path: 'companies'
  },
  {
    component: () => import('@/pages/masterdata/companies/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ Company: PermissionLevel.Write }],
      title: 'createCompany'
    },
    name: 'CreateCompany',
    path: 'companies/create'
  },
  {
    component: () => import('@/pages/masterdata/companies/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ Company: PermissionLevel.Read }],
      title: 'editCompany'
    },
    name: 'EditCompany',
    path: 'companies/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/domains/index.vue'),
    meta: {
      permissions: [{ Domain: PermissionLevel.Read }],
      title: 'menu_domains',
      refreshOnDomainChange: true
    },
    name: 'Domains',
    path: 'domains'
  },
  {
    component: () => import('@/pages/masterdata/domains/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ Domain: PermissionLevel.Write }],
      title: 'createDomain'
    },
    name: 'CreateDomain',
    path: 'domains/create'
  },
  {
    component: () => import('@/pages/masterdata/domains/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ Domain: PermissionLevel.Read }],
      title: 'editDomain'
    },
    name: 'EditDomain',
    path: 'domains/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/workshops/index.vue'),
    meta: {
      permissions: [{ Workshop: PermissionLevel.Read }],
      title: 'menu_workshops'
    },
    name: 'Workshop',
    path: 'workshop'
  },
  {
    component: () => import('@/pages/masterdata/workshops/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ Workshop: PermissionLevel.Write }],
      title: 'createWorkshop'
    },
    name: 'CreateWorkshop',
    path: 'workshops/create'
  },
  {
    component: () => import('@/pages/masterdata/workshops/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ Workshop: PermissionLevel.Read }],
      title: 'editWorkshop'
    },
    name: 'EditWorkshop',
    path: 'workshops/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/suppliers/index.vue'),
    meta: {
      permissions: [{ Supplier: PermissionLevel.Read }],
      title: 'menu_suppliers',
      refreshOnDomainChange: true
    },
    name: 'Supplier',
    path: 'supplier'
  },
  {
    component: () => import('@/pages/masterdata/suppliers/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ Supplier: PermissionLevel.Write }],
      title: 'createSupplier',
      disableDomainChange: true
    },
    name: 'CreateSupplier',
    path: 'suppliers/create'
  },
  {
    component: () => import('@/pages/masterdata/suppliers/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ Supplier: PermissionLevel.Read }],
      title: 'editSupplier',
      disableDomainChange: true
    },
    name: 'EditSupplier',
    path: 'suppliers/edit/:id'
  }
];
